export default "__VITE_PUBLIC_ASSET__d99efa60__"